// TODO: need to fix swag for generate enum
export enum InvoiceTemplateLineCostType {
    InvoiceTemplateLineCostUnlim = 'InvoiceTemplateLineCostUnlim',
    InvoiceTemplateLineCostFixed = 'InvoiceTemplateLineCostFixed',
    InvoiceTemplateLineCostRange = 'InvoiceTemplateLineCostRange',
}
